import { resource, RequestConfig } from '../helper/resource';

/**
 * 高端产品通知订阅-新增订阅
 */
export function addSubUsingPOST(req: HighProdSubDto | void, config?: RequestConfig): Promise<ApiResultHighProdSubDto> {
  return resource.post('/highSub/addSub', req, config);
}

/**
 * 高端产品通知订阅-全部订阅查询
 */
export function getAllSubUsingPOST(
  req: HighSubParam | void,
  config?: RequestConfig
): Promise<ApiResultHighProdAllSubDto> {
  return resource.post('/highSub/getAllSub', req, config);
}

/**
 * 高端产品通知订阅-查询订阅
 */
export function getSubUsingPOST(req: HighSubParam | void, config?: RequestConfig): Promise<ApiResultHighProdSubDto> {
  return resource.post('/highSub/getSub', req, config);
}

/**
 * 高端产品通知订阅-全部订阅修改
 */
export function updateAllSubUsingPOST(
  req: HighProdAllSubDto | void,
  config?: RequestConfig
): Promise<ApiResultHighProdAllSubDto> {
  return resource.post('/highSub/updateAllSub', req, config);
}

/**
 * 高端产品通知订阅-修改订阅
 */
export function updateSubUsingPOST(
  req: HighProdSubDto | void,
  config?: RequestConfig
): Promise<ApiResultHighProdSubDto> {
  return resource.post('/highSub/updateSub', req, config);
}
